export class ToastManager {
  private readonly host: HTMLElement;
  constructor(root: HTMLElement) { this.host = document.createElement('div'); this.host.className = 'toast-stack'; this.host.setAttribute('aria-live', 'polite'); root.append(this.host); }
  show(message: string, kind: 'info' | 'success' | 'error' = 'info'): void {
    const toast = document.createElement('div'); toast.className = `toast toast--${kind}`; toast.textContent = message; this.host.append(toast);
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    window.setTimeout(() => { toast.classList.remove('is-visible'); window.setTimeout(() => toast.remove(), 220); }, 2600);
  }
}
